"use client";

import { AgeType } from "libs/cat-calculations/src/lib/cat-calculations.types";
import { RecipesForCatResponse } from "@forms/schema";
import { IRecipeItem } from "libs/state/src/lib/stores/signupFlow/types";
import {
  getFreshTrialRecipes,
  TraySize,
  DEFAULT_TRIAL_RECIPE_COUNT,
  SEVEN_DAY_TRIAL_COUNT,
} from "libs/recipes/src/lib/recipes";

import { Allergen } from "@/primary-models";

import { useFresh10TestVariant } from "./useDiscountCodeTestVariant";

/**
 * Hook to get fresh trial recipes with automatic tray size selection based on A/B test.
 *
 * - FRESH10 test variant: 7-day trial (7 recipes)
 * - Control: 14-day trial (14 recipes)
 *
 */
export const useFreshTrialRecipes = () => {
  const { isTestVariant } = useFresh10TestVariant();
  const traySize: TraySize = isTestVariant ? SEVEN_DAY_TRIAL_COUNT : DEFAULT_TRIAL_RECIPE_COUNT;

  const getRecipes = (
    allergies: Allergen[],
    lifeStage: AgeType,
    recipeItems?: IRecipeItem[],
  ): RecipesForCatResponse => getFreshTrialRecipes(allergies, lifeStage, recipeItems, traySize);

  return {
    getRecipes,
    traySize,
    isTestVariant,
  };
};
